import { xget, xhttp } from "../Fetchv2";
import { ElasticSchema } from "../schemas/es.schema.js";
import { PGSchema } from "../schemas/pg.schema.js";

type jobApp = { co_id: PGSchema.jobs["co_id"]; job_id: PGSchema.jobs["job_id"]; geo?: PGSchema.jobs["geo"]; referrer: string };
export interface SearchQueryParams {
	from?: number;
	limit?: number;

	ttl?: string;
	cntry?: number[];
	stt?: string[]; // estado/dept
	cntrct?: string[]; // contrto
	exp?: string[]; // experiencia
	stds?: string[]; // experiencia
	areas?: string[]; // experiencia
	wrkdy?: string[]; // experiencia
	ruid?: string[];
	rubros?: string[];
	co?: string[];
	crrncy?: string[];
	internal?: number;
	by?: "date" | "salary" | "relevance";

	status?: PGSchema.jobs["status"][];
	type?: PGSchema.jobs["type"][];
}

export interface SearchQueryParams2 {
	from?: number;
	limit?: number;
	token?: string;

	/** Este solo se usa cuando un admin pide los empleos publicados */
	ttl?: string;
	cntry?: number;
	stt?: string; // estado/dept
	cntrct?: string; // contrto
	exp?: string; // experiencia
	stds?: string; // experiencia
	areas?: string; // experiencia
	wrkdy?: string; // experiencia
	ruid?: string;
	rubros?: string;
	co?: string;
	crrncy?: string;
	internal?: number;
	by?: "date" | "salary" | "relevance";
}

export interface SearchQueryParams3 {
	from?: number;
	limit?: number;
	token?: string;
	/** Este solo se usa cuando un admin pide los empleos publicados */
	ttl?: string | string[];
	cntry?: number | number[];
	stt?: string | string[]; // estado/dept
	cntrct?: string | string[]; // contrto
	exp?: string | string[]; // experiencia
	stds?: string | string[]; // experiencia
	areas?: string | string[]; // experiencia
	wrkdy?: string | string[]; // experiencia
	ruid?: string | string[];
	rubros?: string | string[];
	co?: string | string[];
	crrncy?: string | string[];
	internal?: number;
	by?: "date" | "salary" | "relevance";

	type?: PGSchema.jobs["type"] | PGSchema.jobs["type"][];
}
export interface Filters {
	cntry: ElasticSchema.FilterData[];
	stt: ElasticSchema.FilterData[];
	areas: ElasticSchema.FilterData[];
	cntrct: ElasticSchema.FilterData[];
	exp: ElasticSchema.FilterData[];
	/** studies */
	stds: ElasticSchema.FilterData[];
	wrkdy: ElasticSchema.FilterData[];
	status: ElasticSchema.FilterData[];
	type: ElasticSchema.FilterData[];
	ruid: ElasticSchema.FilterData[];
	internal: ElasticSchema.FilterData[];
}

export class Jobs {
	// @deprecated
	async getAllJobs(pgid: string, body: { skip?: number; limit?: number }) {
		type user = {
			_id: string;
			name: string;
			thumb_pp: string;
			username: string;
			is_verified: boolean;
		};
		let response = await xget<{ user: user; data: PGSchema.jobs[] }>(`/pages/${pgid}/jobs`, body);
		return response;
	}

	async searchJobs(body: SearchQueryParams3) {
		let response = await xhttp<{
			results: Pick<
				PGSchema.jobs,
				| "display_name"
				| "title"
				| "type"
				| "country"
				| "job_id"
				| "status"
				| "co_id"
				| "entity"
				| "state"
				| "published"
				| "currency"
				| "salary"
				| "descrip_short"
				| "hide_company"
				| "open"
				| "close"
			>[];
			filters: Filters;
			USD?: string;
			users: { [key: string]: Pick<PGSchema.pages, "id" | "name" | "username" | "thumb_pp" | "pp" | "is_verified"> };
			entities: { [key: string]: Pick<PGSchema.hcm_entities, "id" | "name" | "pp"> };
		}>(`/search/jobs`, "SEARCH", body);
		return response;
	}

	async getAllPublishedAdminJobs(
		body: {
			where: SearchQueryParams3;
			take?: number;
			skip?: number;
		},
		token?: string
	) {
		let response = await xhttp<{
			results: Pick<
				PGSchema.jobs,
				| "display_name"
				| "title"
				| "type"
				| "country"
				| "job_id"
				| "status"
				| "co_id"
				| "state"
				| "published"
				| "currency"
				| "salary"
				| "descrip_short"
				| "hide_company"
				| "open"
				| "close"
				| "entity"
				| "branches"
			>[];
			filters: Filters;
		}>(`/pages/${body.where.co}/jobs`, "SEARCH", body, { headers: token ? { "app-token": token } : {} });
		return response;
	}

	async getRequisitions(
		body: {
			where: SearchQueryParams3;
			take?: number;
			skip?: number;
		},
		token?: string
	) {
		let response = await xhttp<{
			results: Pick<
				PGSchema.jobs,
				"display_name" | "title" | "type" | "country" | "job_id" | "status" | "co_id" | "state" | "published" | "currency" | "salary" | "descrip_short" | "hide_company" | "open" | "close"
			>[];
			filters: Filters;
		}>(`/pages/${body.where.co}/requisitions`, "SEARCH", body, { headers: token ? { "app-token": token } : {} });
		return response;
	}

	async getJobTemplates(pgid: PGSchema.pages["id"], token: string) {
		let response = await xget<{ data: PGSchema.jobs[] }>(`/pages/${pgid}/job_templates`, {}, { headers: { "app-token": token } });
		return response;
	}

	async sendApplication(body: jobApp) {
		return xhttp<{
			id: number;
			created: boolean;
			uid: string;
			co_id: string;
			job_id: string;
			msg?: string;
			assigned_tests: number[];
		}>(`/users/me/apps`, "POST", body);
	}

	async deleteApplication(body: { co_id: PGSchema.jobs["co_id"]; job_id: PGSchema.jobs["job_id"] }) {
		let response = await xhttp<{ deleted: boolean }>(`/users/me/apps`, "DELETE", body);
		return response;
	}

	async getSavedJobs(body: { skip?: number }) {
		let response = await xget<{
			data: PGSchema.jobs[];
			users: PGSchema.pages[];
		}>(`/users/me/saved-jobs`, body);
		return response;
	}

	async addtoSavedJobs(body: { co_id: PGSchema.jobs["co_id"]; job_id: PGSchema.jobs["job_id"] }) {
		let response = await xhttp<{ inserted: number }>(`/users/me/saved-jobs`, "POST", body);
		return response;
	}

	async deleteSavedJobs(body: { co_id: PGSchema.jobs["co_id"]; job_id: PGSchema.jobs["job_id"] }) {
		let response = await xhttp<{ deleted: boolean }>(`/users/me/saved-jobs`, "DELETE", body);
		return response;
	}

	async updateScore(pgid: string, jobId: number, body: { score: number; uid: string }) {
		return xhttp<{ id: number; overall_score: number; job: PGSchema.users_jobs }>(`/pages/${pgid}/jobs/${jobId}/score`, "PUT", body);
	}
	async getScores(pgid: string, jobId: number, uid: string) {
		return xget<{ overall_score: number; users: { user: Partial<PGSchema.users>; score: number }[] }>(`/pages/${pgid}/jobs/${jobId}/score/users/${uid}`);
	}
}
